/**
 * @module project/components/participate_form/upload_step
 */
import React, { PropTypes, Component } from 'react';
import Cropper from 'react-cropper';
import classNames from 'classnames';
import ParticipateButtons from 'project/containers/participate_buttons';
import FileSelector from 'common/components/file_selector';
import Thumbnail from 'common/components/thumbnail';

/**
 * Participate form step that uploads a new entry image.
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */

const MIN_WIDTH = 800;
const MIN_HEIGHT = 800;

export default class ParticipateUploadStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideCropper: false,
      hideUploader: false,
      thumbnail: null,
      imageData: null,
      fileBlob: null,
      cropperError: null
    };

    this.FileReader = new window.FileReader();

    this.addFile = this.addFile.bind(this);
    this.fileSelected = this.fileSelected.bind(this);
    this.cropImage = this.cropImage.bind(this);
    this.hideCropper = this.hideCropper.bind(this);
  }

  cropImage(event) {
    event.preventDefault();
    const croppedCanvas = this.cropper.getCroppedCanvas();

    if (typeof croppedCanvas === 'undefined') {
      return;
    }

    if (croppedCanvas.width < MIN_WIDTH || croppedCanvas.height < MIN_HEIGHT) {
      this.setState({
        cropperError: `Cropped image must be at least ${MIN_WIDTH} X ${MIN_HEIGHT}.`
      });
      return;
    }

    const thumbnail = this.cropper.getCroppedCanvas().toDataURL();
    this.props.onCrop(thumbnail, thumbnail);
    this.fileSelected(thumbnail, true);
  }

  addFile() {
    this.refs.selector.dropzone.open();
  }

  hideCropper() {
    this.setState({
      hideCropper: true,
      hideUploader: false,
      imageData: null,
      fileBlob: null,
      thumbnail: null,
      cropperError: null
    });
  }

  fileSelected(file, thumbnail) {
    const cropped = thumbnail === undefined ? false : thumbnail;

    if (!cropped) {
      const urlCreator = window.URL || window.webkitURL;
      const imageUrl = urlCreator.createObjectURL(file);
      const changes = {
        fileBlob: file,
        imageData: imageUrl,
        uploaded: true,
        hideCropper: false,
        hideUploader: true,
        cropperError: null
      };

      if (this.state.thumbnail) {
        changes.thumbnail = null;
      }
      this.setState(changes);
    } else {
      this.setState({
        thumbnail: file,
        hideCropper: false,
        hideUploader: true,
        cropperError: null
      });
    }
  }

  renderThumbnail() {
    // @TODO: use ImageUpload component that combines cropper and file uploader
    return (
      <div className="participate-file">
        { this.state.imageData ?
          <div>
            <h3>Crop Image</h3>
            <a className="file-change" onClick={this.addFile}>
              <i className="fa fa-pencil" /> Change Image
            </a>
          </div>
         : null
        }
        { this.state.thumbnail ?
          <div className="thumbnail-preview">
            <Thumbnail className="thumbnail flex" image={this.state.thumbnail} />
          </div>
          : null
        }
        { (this.state.imageData && !this.state.thumbnail && !this.state.hideCropper) ?
          <div className="form-upload-box participate-upload">
            <Cropper
              ref={(c) => { this.cropper = c; }}
              src={this.state.imageData}
              style={{ height: '100%', width: '100%' }}
              guides={false}
              crop={this._crop}
              zoomable={false}
            />

            { this.state.cropperError && <div className="callout alert">
              { this.state.cropperError }
            </div> }

            <button
              type="button"
              className="btn btn-primary btn-md"
              onClick={this.cropImage}
            >Done Cropping</button>
          </div>
          : null
        }
        <div className={classNames({
          hide: this.state.imageData && this.state.hideUploader })}
        >
          <div className="form-upload-box participate-upload">
            <FileSelector
              ref="selector"
              minImageWidth={MIN_WIDTH}
              minImageHeight={MIN_HEIGHT}
              onInvalidOrRejected={this.hideCropper}
              onValidFileSelected={this.fileSelected}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="participate-step file-step">
        <div className="modal-header">
          <h5>Submit Entry</h5>
        </div>
        <div className="modal-content">
          <div className="row expanded collapse">
            <div className="medium-6 columns">
              <div className="participate-sidebar">
                <h3>Tips</h3>
                <ul>
                  <li>Use GIF, JPG or PNG</li>
                  <li>Use RGB colorspace</li>
                  <li>{MIN_WIDTH}px x {MIN_HEIGHT}px minimum, but the bigger the better</li>
                  <li>Use image with light or dark background</li>
                  <li>10mb max file size</li>
                </ul>
                { this.props.isRevision ?
                  <div>
                    <h5>Revision of</h5>
                    <img className="thumbnail-wrap" src={this.props.revision.thumbnail} />
                    <a href="#"
                      className="change-revision"
                      onClick={this.props.onChangeEntry}
                    >Change</a>
                  </div> : null
                }
              </div>
            </div>
            <div className="medium-10 columns">
              {this.renderThumbnail()}
            </div>
          </div>
          <div className="modal-actions right">
            <ParticipateButtons
              nextActive={!!this.state.thumbnail}
              onToggleForm={this.props.onCloseForm}
            />
          </div>
        </div>
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {bool} isRevision - controls if current entry is a revision or new entry
 * @property {object} revision - revision data object
 * @property {func} onCrop - function called when image is cropped
 * @property {func} onChangeEntry - function called when change entry button is clicked
 * @property {func} onCloseForm - function called when close form button is clicked
 */
ParticipateUploadStep.propTypes = {
  isRevision: PropTypes.bool,
  revision: PropTypes.object,
  onCrop: PropTypes.func,
  onChangeEntry: PropTypes.func,
  onCloseForm: PropTypes.func,
};



// WEBPACK FOOTER //
// ./project/components/participate_form/upload_step.jsx